
export const appLicenseData = (state) => state.apps.appLicenseData
export const loadingAppLicenseData = (state) => state.apps.loadingAppLicenseData
